import { observer } from 'mobx-react-lite';
import { Icon, Spinner, SpinnerSize } from '@fluentui/react/lib';
import { assertNever } from 'owa-assert';
import { ControlIcons } from 'owa-control-icons';
import * as React from 'react';
import { InsertLinksStatus } from '../types/InsertLinksStatus';
import { getBlockDialogOnSendLabelString } from '../utils/getBlockDialogOnSendLabelString';
import { getBlockDialogOnSaveLabelString } from '../utils/getBlockDialogOnSaveLabelString';
import { getInsertLinksStatusData } from '../utils/getInsertLinksStatusData';

const styles = require('./InsertLinksBlockDialog.scss');

export interface InsertLinksBlockDialogProps {
    insertLinksIds: string[];
    isSend: boolean;
}

export const InsertLinksBlockDialog: React.FunctionComponent<InsertLinksBlockDialogProps> = observer(
    function InsertLinksDialog(props: InsertLinksBlockDialogProps) {
        const { status, fileNames } = getInsertLinksStatusData(props.insertLinksIds);
        const iconToShow = getDialogIconData(status);

        // Block dialog is supported in either send or save.
        const labelString: string = props.isSend
            ? getBlockDialogOnSendLabelString(status, fileNames)
            : getBlockDialogOnSaveLabelString(status, fileNames);
        return (
            <div className={styles.dialogContainer}>
                {iconToShow}
                <div>{labelString}</div>
            </div>
        );
    }
);

function getDialogIconData(insertLinksStatus: InsertLinksStatus): JSX.Element {
    switch (insertLinksStatus) {
        case InsertLinksStatus.succeededToAddOneLink:
        case InsertLinksStatus.succeededToAddMultipleLinks:
            return <Icon className={styles.checkMarkIcon} iconName={ControlIcons.CheckMark} />;
        case InsertLinksStatus.failedToInsertOneLink:
        case InsertLinksStatus.failedToInsertMultipleLinks:
            return <Icon className={styles.cancelIcon} iconName={ControlIcons.Cancel} />;
        case InsertLinksStatus.loadingOneLink:
        case InsertLinksStatus.loadingMultipleLinks:
            return <Spinner size={SpinnerSize.medium} className={styles.spinner} />;
        default:
            return assertNever(insertLinksStatus);
    }
}
